<template>
  <div class="notices-page">

    <!-- 鼠标光晕 -->
    <div class="cursor-glow" ref="cursorGlow"></div>

    <!-- =================== Hero =================== -->
    <div class="hero" ref="hero">
      <div class="orb orb--1" ref="orb1"></div>
      <div class="orb orb--2" ref="orb2"></div>
      <div class="hero__overlay"></div>

      <div class="hero__body">
        <div class="hero__badge" ref="heroBadge">
          <span class="hero__dot"></span>公告信息
        </div>
        <div class="clip-wrap">
          <h1 class="hero__title clip-inner">与每一种力量<br />共筑智慧、便捷、美好生活</h1>
        </div>
        <div class="clip-wrap" style="margin-top:.6rem;">
          <p class="hero__sub clip-inner">AND EVERY POWER · BUILD A SMART, CONVENIENT AND BETTER LIFE</p>
        </div>
        <div class="hero__actions" ref="heroActions">
          <button class="btn-primary magnetic" @click="applyShow">立即申请试用</button>
        </div>
      </div>
    </div>

    <!-- =================== 公告列表 =================== -->
    <div class="notices-section" ref="noticesSection">
      <div class="sec__inner">

        <!-- Section 标题 -->
        <div class="sec__head" ref="secHead">
          <span class="sec__label reveal-chip">ANNOUNCEMENT</span>
          <div class="title-mask">
            <h2 class="title-mask__inner">招标公告</h2>
          </div>
          <p class="sec__desc" ref="secDesc">公开透明，及时发布最新招标与公告信息</p>
        </div>

        <!-- 公告卡片网格 -->
        <div class="notice-grid" v-if="caseData.length">
          <div
            v-for="(item, index) in caseData"
            :key="index"
            class="notice-card"
            ref="noticeCards"
            @click="goDetail(item)"
          >
            <!-- 封面图 -->
            <div class="notice-card__cover">
              <img :src="item.img" :alt="item.title" />
              <div class="notice-card__cover-mask"></div>
              <!-- 悬浮品类角标 -->
              <span class="notice-card__cat">招标公告</span>
              <!-- 日期浮层 -->
              <div class="notice-card__date-badge">
                <span class="notice-card__day">{{ item.time.split('-')[2] }}</span>
                <span class="notice-card__ym">{{ item.time.split('-')[0] }}-{{ item.time.split('-')[1] }}</span>
              </div>
            </div>

            <!-- 内容区 -->
            <div class="notice-card__body">
              <!-- 背景序号 -->
              <span class="notice-card__bg-num" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>

              <h3 class="notice-card__title">{{ item.title }}</h3>
              <div class="notice-card__bar"></div>
              <p class="notice-card__desc">{{ item.content }}</p>

              <div class="notice-card__footer">
                <span class="notice-card__tag">招标公告</span>
                <span class="notice-card__link">
                  查看详情
                  <span class="notice-card__arrow">
                    <i class="el-icon-d-arrow-right"></i>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-else class="notice-empty" ref="noticeEmpty">
          <div class="notice-empty__icon">
            <i class="el-icon-document"></i>
          </div>
          <h3 class="notice-empty__title">暂无公告信息</h3>
          <p class="notice-empty__sub">请稍后查看，我们将及时发布最新公告</p>
        </div>

      </div>
    </div>

    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import ApplyDialog from '../components/applyDialog.vue'

gsap.registerPlugin(ScrollTrigger)

export default {
  components: { ApplyDialog },
  data() {
    return {
      show: false,
      caseData: [
        {
          img: require('../assets/ht.png'),
          title: '员工食堂食材配送服务 中标公告',
          /** 详情页正文段落，用换行符分段 */
          content: '我司员工食堂食材配送服务项目以内部邀标形式进行招标，招标配送品类：蔬菜、水果、肉禽、鲜蛋、奶制品、豆制品、冻品、粮油、干货、调味品等。经评标小组综合考察评审，最终确定一家中标单位，现将中标结果公告如下：\n服务期限：一年。\n特此公告！',
          /** 结构化信息卡片（可选，无则不显示） */
          infoItems: [
            { icon: 'el-icon-document', label: '招标项目',  value: '员工食堂食材配送服务项目' },
            { icon: 'el-icon-medal-1',  label: '中标供应商', value: '中鲜（厦门）食品科技有限公司' },
            { icon: 'el-icon-star-on',  label: '综合评审',  value: '第一名 · 95 分' },
            { icon: 'el-icon-goods',    label: '供应品类',  value: '蔬菜、水果、肉禽、鲜蛋、奶制品、豆制品、冻品、粮油、干货、调味品等' },
          ],
          type: '1',
          time: '2023-03-10',
        },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this._initCursorGlow()
      this._initHeroAnimations()
      this._initSectionHead()
      this._initNoticeCards()
      this._initMagnetic()
    })
  },

  beforeDestroy() {
    ScrollTrigger.getAll().forEach(t => t.kill())
    document.removeEventListener('mousemove', this._cursorHandler)
  },

  methods: {
    /* ─── 鼠标光晕 ─── */
    _initCursorGlow() {
      const glow = this.$refs.cursorGlow
      if (!glow) return
      this._cursorHandler = (e) => {
        gsap.to(glow, { x: e.clientX, y: e.clientY, duration: 0.6, ease: 'power2.out' })
      }
      document.addEventListener('mousemove', this._cursorHandler)
    },

    /* ─── Hero 入场 ─── */
    _initHeroAnimations() {
      if (this.$refs.orb1) gsap.to(this.$refs.orb1, { y: -50, x: 25, duration: 5, repeat: -1, yoyo: true, ease: 'sine.inOut' })
      if (this.$refs.orb2) gsap.to(this.$refs.orb2, { y: 40,  x: -30, duration: 6.5, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1 })

      const tl = gsap.timeline({ delay: 0.2 })
      tl.from(this.$refs.heroBadge, { scale: 0, opacity: 0, duration: 0.5, ease: 'back.out(2)' })
        .from('.clip-inner', { yPercent: 105, opacity: 0, duration: 0.9, ease: 'expo.out', stagger: 0.18 }, '-=0.2')
        .from(Array.from(this.$refs.heroActions?.children || []), { y: 24, opacity: 0, duration: 0.5, ease: 'power3.out', stagger: 0.1 }, '-=0.4')

      gsap.to(this.$refs.orb1, { y: -100, ease: 'none',
        scrollTrigger: { trigger: this.$refs.hero, scrub: 1, start: 'top top', end: 'bottom top' } })
    },

    /* ─── Section 标题揭示 ─── */
    _initSectionHead() {
      const chip = this.$el.querySelector('.reveal-chip')
      const titleInner = this.$el.querySelector('.title-mask__inner')
      const desc = this.$refs.secDesc

      if (chip) {
        gsap.fromTo(chip, { x: -20, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.6, ease: 'power3.out',
            scrollTrigger: { trigger: chip, start: 'top 88%', once: true }, clearProps: 'transform,opacity' })
      }
      if (titleInner) {
        gsap.fromTo(titleInner, { yPercent: 110 },
          { yPercent: 0, duration: 1, ease: 'expo.out',
            scrollTrigger: { trigger: titleInner, start: 'top 88%', once: true }, clearProps: 'transform' })
      }
      if (desc) {
        gsap.fromTo(desc, { y: 16, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out', delay: 0.3,
            scrollTrigger: { trigger: desc, start: 'top 90%', once: true }, clearProps: 'transform,opacity' })
      }
    },

    /* ─── 公告卡片：scrub clip-path 揭示 + 封面视差 ─── */
    _initNoticeCards() {
      const cards = Array.from(this.$el.querySelectorAll('.notice-card'))
      if (!cards.length) {
        /* 空状态淡入 */
        const empty = this.$refs.noticeEmpty
        if (empty) {
          gsap.fromTo(empty,
            { y: 40, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.8, ease: 'expo.out',
              scrollTrigger: { trigger: empty, start: 'top 85%', once: true }, clearProps: 'transform,opacity' })
        }
        return
      }

      /* scrub timeline：卡片随滚动错落升起 */
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cards[0],
          start: 'top 88%',
          end: 'top 40%',
          scrub: 0.6,
        },
      })
      cards.forEach((card, i) => {
        tl.fromTo(card,
          { y: 70, opacity: 0, scale: 0.9 },
          { y: 0, opacity: 1, scale: 1, duration: 0.55, ease: 'power3.out' },
          i * 0.07
        )
      })

      /* 封面图内部视差 */
      cards.forEach((card) => {
        const img = card.querySelector('.notice-card__cover img')
        if (img) {
          gsap.to(img, {
            yPercent: -12, ease: 'none',
            scrollTrigger: { trigger: card, scrub: 1.2, start: 'top bottom', end: 'bottom top' },
          })
        }
      })
    },

    /* ─── 磁性按钮 ─── */
    _initMagnetic() {
      this.$el.querySelectorAll('.magnetic').forEach((btn) => {
        btn.addEventListener('mousemove', (e) => {
          const r = btn.getBoundingClientRect()
          gsap.to(btn, {
            x: (e.clientX - r.left - r.width  / 2) * 0.35,
            y: (e.clientY - r.top  - r.height / 2) * 0.35,
            duration: 0.3, ease: 'power2.out',
          })
        })
        btn.addEventListener('mouseleave', () => {
          gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.5)' })
        })
      })
    },

    /** 弹出申请试用弹窗 */
    applyShow() {
      this.show = true
      this.noScroll()
    },
    /**
     * 跳转公告详情页，用 sessionStorage 传递完整数据
     * @param {Object} item - 公告对象
     */
    goDetail(item) {
      sessionStorage.setItem('noticeDetail', JSON.stringify({
        title:     item.title     || '',
        content:   item.content   || '',
        time:      item.time      || '',
        img:       item.img       || '',
        type:      item.type      || '0',
        infoItems: item.infoItems || [],
      }))
      this.$router.push({ path: '/notices/details' })
    },
  },
}
</script>

<style lang="scss" scoped>
$blue:   #0E6EB8;
$blue-l: #38A0F5;
$dark:   #0D1B2E;
$tint:   #F0F7FF;
$muted:  #6B7280;
$r-xl:   1.25rem;
$tr:     all .3s cubic-bezier(.4,0,.2,1);

/* ─── 光晕 ─── */
.cursor-glow {
  position: fixed; width: 28rem; height: 28rem; border-radius: 50%;
  background: radial-gradient(circle, rgba(14,110,184,.1), transparent 70%);
  pointer-events: none; transform: translate(-50%,-50%); z-index: 9990;
  mix-blend-mode: screen; will-change: transform;
}

/* ─── Hero ─── */
.hero {
  height: 44rem;
  background: url('../assets/cooperation6.png') no-repeat center center / cover;
  position: relative; display: flex; align-items: center; overflow: hidden;

  .orb {
    position: absolute; border-radius: 50%; filter: blur(90px);
    pointer-events: none; z-index: 1; will-change: transform;
  }
  .orb--1 { width: 38rem; height: 38rem; background: rgba(14,110,184,.28); top: -10rem; right: -4rem; }
  .orb--2 { width: 24rem; height: 24rem; background: rgba(56,160,245,.2); bottom: 2rem; left: 38%; }

  &__overlay {
    position: absolute; inset: 0; z-index: 1;
    background: linear-gradient(110deg, rgba(8,28,60,.82) 0%, rgba(14,110,184,.38) 55%, rgba(0,0,0,.06) 100%);
  }
  &__body { position: relative; z-index: 3; padding: 0 7.5rem; max-width: 58%; }
  &__badge {
    display: inline-flex; align-items: center; gap: .5rem;
    background: rgba(255,255,255,.12); backdrop-filter: blur(12px);
    border: 1px solid rgba(255,255,255,.25); color: #fff;
    font-size: .78rem; font-weight: 600; letter-spacing: .08em;
    padding: .38rem .95rem; border-radius: 5rem; margin-bottom: 1.2rem;
  }
  &__dot { width: .45rem; height: .45rem; border-radius: 50%; background: $blue-l; animation: pulse 2s infinite; }
  &__title {
    font-size: 2.5rem; font-weight: 800; color: #fff;
    line-height: 1.4; margin: 0 0 .6rem; text-shadow: 0 2px 20px rgba(0,0,0,.35);
  }
  &__sub   { font-size: .78rem; color: rgba(255,255,255,.7); letter-spacing: .06em; margin: 0 0 2rem; }
  &__actions { display: flex; gap: 1rem; }
}

.clip-wrap { overflow: hidden; line-height: 1; }
.clip-inner { display: block; }

/* ─── 按钮 ─── */
.btn-primary {
  padding: .9rem 2.4rem; background: linear-gradient(135deg, $blue, $blue-l);
  color: #fff; font-size: .95rem; font-weight: 700; border-radius: 3rem;
  border: none; cursor: pointer; box-shadow: 0 6px 20px rgba(14,110,184,.4);
  transition: $tr; will-change: transform;
  &:hover { box-shadow: 0 10px 30px rgba(14,110,184,.55); }
}

/* ─── 公告区域 ─── */
.notices-section {
  background: linear-gradient(180deg, $tint 0%, #fff 100%);
  padding: 0 0 6rem; min-height: 32rem;
}
.sec__inner { max-width: 1400px; margin: 0 auto; padding: 0 7.5rem; }
.sec__head  { text-align: center; padding: 5rem 0 4rem; }

.sec__label {
  display: inline-block; font-size: .72rem; font-weight: 700; letter-spacing: .2em;
  color: $blue; background: rgba(14,110,184,.09);
  padding: .3rem .9rem; border-radius: 5rem; margin-bottom: .8rem;
}
.title-mask { overflow: hidden; margin-bottom: .7rem; }
.title-mask__inner { display: block; font-size: 2.4rem; font-weight: 800; color: #1A2535; margin: 0; }
.sec__desc  { font-size: .95rem; color: $muted; margin: 0; }

/* ─── 公告卡片网格 ─── */
.notice-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(22rem, 1fr));
  gap: 1.75rem;
}

/* ─── 公告卡片 ─── */
.notice-card {
  background: #fff;
  border: 1px solid rgba(14,110,184,.1);
  border-radius: $r-xl;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(14,110,184,.07);
  cursor: pointer;
  transition: box-shadow .35s ease, border-color .35s ease, transform .35s ease;
  will-change: transform;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 24px 55px rgba(14,110,184,.18);
    border-color: rgba(14,110,184,.28);

    .notice-card__cover img { transform: scale(1.07); }
    .notice-card__bar       { transform: scaleX(1.8); }
    .notice-card__arrow     { transform: translateX(5px); opacity: 1; }
    .notice-card__link      { color: $blue; }
    .notice-card__cover-mask { opacity: .45; }
  }

  /* 封面图区 */
  &__cover {
    position: relative; height: 13rem; overflow: hidden; background: #eef5fb;

    img {
      width: 100%; height: 100%; object-fit: cover;
      transition: transform .6s cubic-bezier(.4,0,.2,1);
      will-change: transform;
    }
  }
  &__cover-mask {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(14,110,184,.35), transparent 60%);
    opacity: .25; transition: opacity .35s ease; pointer-events: none;
  }

  /* 品类角标（图片左上） */
  &__cat {
    position: absolute; top: 1rem; left: 1rem; z-index: 2;
    background: rgba(14,110,184,.85); backdrop-filter: blur(10px);
    color: #fff; font-size: .68rem; font-weight: 700; letter-spacing: .08em;
    padding: .25rem .8rem; border-radius: 5rem;
    border: 1px solid rgba(255,255,255,.25);
  }

  /* 日期浮层（图片右下） */
  &__date-badge {
    position: absolute; bottom: 1rem; right: 1rem; z-index: 2;
    background: rgba(255,255,255,.95); backdrop-filter: blur(10px);
    border-radius: .75rem; padding: .4rem .85rem; text-align: center;
    box-shadow: 0 4px 16px rgba(0,0,0,.15);
  }
  &__day {
    display: block; font-size: 1.7rem; font-weight: 900; color: $blue;
    line-height: 1; font-family: 'Arial', sans-serif;
  }
  &__ym {
    display: block; font-size: .65rem; color: $muted; margin-top: .15rem;
    letter-spacing: .03em;
  }

  /* 内容区 */
  &__body {
    position: relative; padding: 1.5rem 1.75rem 1.75rem; overflow: hidden;
  }
  &__bg-num {
    position: absolute; top: .5rem; right: 1.25rem;
    font-size: 5rem; font-weight: 900; line-height: 1;
    color: rgba(14,110,184,.05); pointer-events: none;
    letter-spacing: -.05em; user-select: none;
  }
  &__title {
    font-size: 1rem; font-weight: 800; color: #1A2535; margin: 0 0 .7rem;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
    overflow: hidden; line-height: 1.55;
  }
  &__bar {
    width: 2.5rem; height: 3px;
    background: linear-gradient(90deg, $blue, $blue-l);
    border-radius: 3px; margin-bottom: 1rem;
    transform-origin: left; transition: transform .4s ease;
  }
  &__desc {
    font-size: .85rem; color: $muted; margin: 0 0 1.25rem;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
    overflow: hidden; line-height: 1.7;
  }
  &__footer {
    display: flex; align-items: center; justify-content: space-between;
  }
  &__tag {
    font-size: .7rem; font-weight: 700; color: $blue;
    background: rgba(14,110,184,.09); border: 1px solid rgba(14,110,184,.15);
    padding: .22rem .65rem; border-radius: 5rem; letter-spacing: .04em;
  }
  &__link {
    display: flex; align-items: center; gap: .35rem;
    font-size: .82rem; font-weight: 700; color: $muted;
    transition: color .25s ease;
  }
  &__arrow {
    display: inline-flex; align-items: center;
    transition: transform .3s ease, opacity .3s ease;
    opacity: .5;
  }
}

/* ─── 空状态 ─── */
.notice-empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  padding: 6rem 0; text-align: center;

  &__icon {
    width: 6rem; height: 6rem;
    background: linear-gradient(135deg, rgba(14,110,184,.12), rgba(56,160,245,.08));
    border: 2px dashed rgba(14,110,184,.2);
    border-radius: 1.5rem;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.5rem;

    i { font-size: 2.5rem; color: rgba(14,110,184,.4); }
  }
  &__title {
    font-size: 1.25rem; font-weight: 800; color: #1A2535; margin: 0 0 .6rem;
  }
  &__sub {
    font-size: .9rem; color: $muted; margin: 0;
  }
}

/* ─── Keyframes ─── */
@keyframes pulse {
  0%,100% { opacity: 1; transform: scale(1); }
  50%      { opacity: .5; transform: scale(1.4); }
}
</style>

<style>
@media screen and (max-width: 600px) {
  .cursor-glow { display: none; }
  .notices-page .hero { margin-top: 70px; min-height: 28rem; height: auto !important; padding: 3rem 0; }
  .hero__body  { padding: 0 1.5rem !important; max-width: 100% !important; }
  .notice-grid { grid-template-columns: 1fr !important; }
  .sec__inner  { padding: 0 1.5rem !important; }
}
</style>
